export const RESET_TRANSFER_CHAT = "RESET_TRANSFER_CHAT";
export const API_ERROR = "TRANSFER_CHAT_API_ERROR";

export const GET_TRANSFER_CHAT = "GET_TRANSFER_CHAT";
export const SET_TRANSFER_CHAT = "SET_TRANSFER_CHAT";

export const TRANSFER_CHAT = "TRANSFER_CHAT";
export const TRANSFERED_CHAT = "TRANSFERED_CHAT";
